/**
 * Global date formatter for Garment360.
 * Format: dd-mm-yy (e.g., 19-03-26)
 */
export const fmtDateGlobal = (d) => {
  if (!d) return '';
  try {
    const dt = typeof d === 'string' ? new Date(d) : d;
    if (isNaN(dt.getTime())) return d;
    const dd = String(dt.getDate()).padStart(2, '0');
    const mm = String(dt.getMonth() + 1).padStart(2, '0');
    const yy = String(dt.getFullYear()).slice(-2);
    return `${dd}-${mm}-${yy}`;
  } catch {
    return d;
  }
};

/**
 * Date+Time formatter: dd-mm-yy hh:mm AM/PM
 */
export const fmtDateTimeGlobal = (d) => {
  if (!d) return '';
  try {
    const dt = typeof d === 'string' ? new Date(d) : d;
    if (isNaN(dt.getTime())) return d;
    const dd = String(dt.getDate()).padStart(2, '0');
    const mm = String(dt.getMonth() + 1).padStart(2, '0');
    const yy = String(dt.getFullYear()).slice(-2);
    let h = dt.getHours();
    const min = String(dt.getMinutes()).padStart(2, '0');
    const ampm = h >= 12 ? 'PM' : 'AM';
    h = h % 12 || 12;
    return `${dd}-${mm}-${yy} ${h}:${min} ${ampm}`;
  } catch {
    return d;
  }
};
